<template>
    <v-container container--fluid>
        <v-layout row wrap align-center justify-space-around class="pa-2 mx-auto">
            <v-flex xs12 class="text-left">
                <h1 class="grey--text lighten-3 mb-2">Competition Roster</h1>

                <v-overlay :value="loading">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </v-overlay>
                <v-row>
                    <v-col cols="12" sm="4" md="4">
                        <v-autocomplete
                            :loading="loading"
                            item-text="season_name"
                            item-value="season_id"
                            v-model.trim="sel_season"
                            :items="seasons"
                            label="Seasons"
                            hint="Select a season"
                            persistent-hint
                            outlined
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                       <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field outlined v-model="dateRangeText" label="Roster Date Range" persistent-hint hint="Select one or 2 dates as a range" prepend-inner-icon="event" readonly v-on="on"></v-text-field>
                            </template>
                            <v-date-picker range no-title scrollable v-model="roster_date">
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="roster_date = [];">Clear</v-btn>
                                <v-btn text color="primary" @click="menu = false;">Cancel</v-btn>
                                <v-btn text color="primary" @click="menu = false;">OK</v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-btn block class="btnShowRoster" :loading="loading" color="primary" @click="getRoster">MY ROSTER<v-icon right>schedule</v-icon></v-btn>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <v-autocomplete
                            :loading="loading"
                            v-model.trim="sel_type"
                            :items="types"
                            label="Roster Type"
                            hint="Select a competition roster type"
                            persistent-hint
                            outlined
                            clearable
                        ></v-autocomplete>
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-btn block class="btnShowRoster" :loading="loading" color="primary" @click="getFullRoster">FULL ROSTER<v-icon right>schedule</v-icon></v-btn>
                    </v-col>
                </v-row>

                <div v-if="roster.roster && showRoster">
                    <v-row v-for="(game, index) in roster.roster" :key="index">
                        <div class="col mt-4 round-wrapper pa-0">
                            <v-col cols="12">
                                <v-flex>
                                    <v-card class="d-flex flex-column pa-3 mb-1 draw-card" raised>
                                        <div class="text-center mb-2"><v-icon color="primary" left>calendar_today</v-icon> {{ game.gs_date_formatted }}</div>
                                        <div class="text-center mb-2"><v-btn color="secondary" :href="venueLink(game)" target="_blank" class="btnLoc pa-0 mx-1"><v-icon color="primary" left class="mx-0">location_on</v-icon></v-btn> {{ game.venue_name }}</div>

                                        <div class="text-center">{{ game.division_name }}</div>
                                        <div class="text-center" v-if="game.game_rank">{{ game.game_rank }}</div>
                                        <v-divider class="my-3"></v-divider>
                                        <div class="text-center"><b>Roster Type:</b> {{ game.member_type_name }}</div>
                                        <v-divider class="my-3"></v-divider>
                                        <div class="d-flex justify-space-around mb-3 flex-basis-third">
                                            <div class="text-center">{{ game.team_a }}</div>
                                            <div class="text-center font-weight-bold mobile">
                                                {{ game.gs_time_formatted }} <v-icon color="primary" left right class="mx-1 mt-n1">alarm</v-icon> {{ game.court_name }}
                                            </div>
                                            <div class="text-center">{{ game.team_b }}</div>
                                        </div>
                                        <v-divider class="my-3"></v-divider>
                                        <div class="text-center" v-if="!game.team_a_points && !game.team_b_points">
                                            <v-btn color="secondary" :href="genGoogLinkCal(game)" target="_blank" class="btnCal ma-2"><i class="fas fa-calendar-plus pr-2"></i>Add to Google Calendar</v-btn>
                                            <v-btn color="primary" @click="genICal(game)" class="btnCal my-2"><i class="fas fa-calendar-plus pr-2"></i>Add to Apple Calendar</v-btn>
                                        </div>
                                    </v-card>
                                </v-flex>
                            </v-col>
                        </div>
                    </v-row>
                </div>
                <div v-if="roster.full_roster && showFullRoster">
                    <div class="col mt-4 round-wrapper pa-0" v-html="roster.full_roster"></div>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import store from "@modules/referee/_store";
import moment from "moment";
import { downloadIcs, formatLocation, googleCalendarUrl } from "@shared/calendar";

export default {
    name: "referee",
    data() {
        return {
            sel_season: null,
            sel_type: null,
            roster_date: [],//moment().format("YYYY-MM-DD"),
            menu: false,
            showRoster: false,
            showFullRoster: false,
        };
    },
    computed: {
        dateRangeText () {
            if(this.roster_date.length > 1){
                let start = this.roster_date[0];
                let end = this.roster_date[1];
                if(moment(this.roster_date[1]).isBefore(this.roster_date[0])){
                    this.roster_date[0] = end;
                    this.roster_date[1] = start;
                }
            }
            return this.roster_date.length ? this.roster_date.map(item => moment(item).format("DD/MM/YYYY")).join(" ~ ") : "";
        },
        computedDateFormatted() {
            return this.roster_date ? moment(this.roster_date).format("DD/MM/YYYY") : "";
        },
        loading() {
            return this.$store.getters["referee/refereeStatus"] == "loading";
        },
        seasons() {
            return this.$store.getters["referee/seasons"];
        },
        types() {
            return this.$store.getters["user/getProfile"].access_ref;
        },
        roster() {
            return this.$store.getters["referee/roster"];
        },
    },
    methods: {
        getRoster() {
            if (this.sel_season /*&& this.roster_date*/) {
                const { sel_season, roster_date, sel_type } = this;

                this.$store.dispatch("referee/getRoster", { sel_season, roster_date, sel_type });
                this.showRoster = true;
                this.showFullRoster = false;
            }
        },
        getFullRoster() {
            if (this.sel_season && this.roster_date) {
                const { sel_season, roster_date, sel_type } = this;

                this.$store.dispatch("referee/getRoster", { sel_season, roster_date, sel_type });
                this.showRoster = false;
                this.showFullRoster = true;
            }
        },
        venueLink(game){
            return encodeURI("https://www.google.com/maps/search/" + (game.venue_name ? game.venue_name : "") + " " + (game.venue_address ? game.venue_address : "") + " " + (game.venue_suburb ? game.venue_suburb : "") + " " + (game.venue_postcode ? game.venue_postcode : "") + " " + (game.venue_state ? game.venue_state : ""));
        },
        calendarEvent(game) {
            let start = moment(game.gs_date, "YYYY-MM-DD").set({
                hour: moment(game.gs_time, "HH:mm:ss").hour(),
                minute: moment(game.gs_time, "HH:mm:ss").minute(),
                second: 0,
            });

            return {
                uid: game.gs_game,
                title: this.appNameUrls.client + " - Competition Roster",
                start: start,
                end: start.clone().add(45, "minutes"),
                location: formatLocation({
                    name: game.venue_name,
                    address: game.venue_address,
                    suburb: game.venue_suburb,
                    state: game.venue_state,
                    postcode: game.venue_postcode,
                }),
                descriptionLines: [
                    game.division_name,
                    game.team_a + " vs " + game.team_b,
                    game.court_name + " @ " + game.gs_time_formatted + " on " + game.gs_date_formatted,
                ],
                timezone: this.lmpTz,
                filename: "competition-roster.ics",
            };
        },
        genGoogLinkCal(game) {
            return googleCalendarUrl(this.calendarEvent(game));
        },
        genICal(game) {
            downloadIcs(this.calendarEvent(game));
        },
    },
    beforeCreate() {
        this.$store.dispatch("referee/getSeasons");
        // if(_.isEmpty(this.$store.getters['referee/roster'])){
        //     this.$store.dispatch('referee/getRoster');
        // }
    },
};
</script>

<style lang="scss">
.roster-card {
    &:hover {
        background-color: var(--drawer-color) !important;
        border-color: var(--drawer-color) !important;
        color: #fff !important;
        caret-color: #fff !important;
    }
}
.flex-basis-third {
    div {
        flex: 1 1 33.33%;
    }
}
.round-wrapper {
    .col.col-12 .flex:nth-of-type(n + 2) .bye-duty-team {
        display: none !important;
    }
}

.v-text-field__slot {
    input {
        border: none !important;
    }
}

.btnShowRoster {
    min-height: 56px;
}

#referee_roster_table {
    width: 100%;
    border-spacing: 0px;
    font-size: 14px;

    thead {
        th {
            padding: 10px 5px;
            font-weight: bold;
            color: #fff;
            background: var(--primary-color) !important;
            text-align: left;

            &.hide-non-mobile {
                // display: none;
            }
        }
    }

    tr {
        &:nth-child(even) {
            // background: #fff;
        }

        &:nth-child(odd) {
            // background: #e0e0e0;
        }

        td {
            padding: 10px 5px;
            text-align: left;
            border: 0.1px solid #000000;
        }
    }
}

@media screen and (max-width: 767px) {
    .btnCal {
        min-width: 100% !important;
    }

    .btnLoc {
        min-width: 34px !important;
        height: 22px !important;
    }

    #referee_roster_table {
        th {
            width: 100% !important;
        }

        tr {
            border-bottom: 3px solid #000 !important;
            display: block;
        }

        th {
            display: none !important;
        }

        td {
            display: block !important;

            b {
                font-weight: normal !important;
            }

            &:before {
                content: attr(data-title) ": ";
                font-weight: bold;
            }

            br {
                display: none;
            }

            &.no-content {

                &:before {
                    content: "";
                }
            }
        }
    }
}
</style>
